import { type FunctionComponent } from "react";

import prebuiltmlIcon from "images/Common/prebuiltml.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedPrebuiltml: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={prebuiltmlIcon} style={baseProps.style} className={baseProps.className} />
    );
};
